var WDN = WDN || {};

if (typeof WDN.Request === "undefined") {
  WDN.Request = (function () {
    // Private function
    var _do;

    // Public function
    var Get, Post;

    var config = {
      defaultContentType: "application/json;charset=UTF-8",
      version: "1.1.2",
    };

    _do = function (obj) {
      var req = new XMLHttpRequest();

      if (obj.method == "POST" || obj.method == "PUT") {
        var contentType = obj.contentType || config.defaultContentType;
        req.open(obj.method, obj.url);
        req.setRequestHeader("Content-Type", contentType);
      }

      req.onreadystatechange = function () {
        if (req.readyState == 4) {
          if (req.status > 399 && req.status < 600) {
            if (obj.onError) {
              obj.onError(req.responseText);
            }
          }
          if (req.status == 200) {
            if (obj.onSuccess) {
              obj.onSuccess(req.responseText);
            }
          }
        }
      };

      if (obj.method == "POST" || obj.method == "PUT") {
        if (obj.contentType && obj.contentType !== config.defaultContentType) {
          req.send(obj.data);
        } else {
          req.send(JSON.stringify(obj.data));
        }
      } else {
        req.open("GET", obj.url, true);
        req.send(null);
      }

      return req;
    };

    Get = function (obj) {
      return _do({
        method: "GET",
        url: obj.url,
        onSuccess: function (res) {
          obj.type == "JSON" ? obj.onSuccess(JSON.parse(res)) : obj.onSuccess(res);
        },
        onError: function (res) {
          if (obj.onError) {
            if (obj.type == "JSON") {
              obj.onError(JSON.parse(res));
            } else {
              obj.onError(res);
            }
          }
        },
      });
    };

    Post = function (obj) {
      _do({
        method: "POST",
        url: obj.url,
        data: obj.data,
        contentType: obj.contentType,
        onSuccess: function (res) {
          obj.onSuccess(JSON.parse(res));
        },
        onError: function (res) {
          if (obj.onError) {
            obj.onError(res);
          }
        },
      });
    };

    return {
      Get: Get,
      Post: Post,
      Version: config.version,
    };
  })();
}
